import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import {
  type IPatient,
  isPatient,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef, isWithRef, snapshot } from '@principle-theorem/shared';
import { ManagementResource } from '../models/management-resource';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';
import {
  type IDeduplicatePatientMediaDialogData,
  DeduplicatePatientMediaDialogComponent,
} from '../deduplicate-patient-media-dialog/deduplicate-patient-media-dialog.component';

function isPatientWithRef(value: unknown): value is WithRef<IPatient> {
  return isPatient(value) && isWithRef<IPatient>(value);
}

@Injectable({ providedIn: 'root' })
export class DeduplicatePatientMediaTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);

  readonly name = 'deduplicate-patient-media';
  readonly label = 'Deduplicate Patient Media';
  readonly icon = 'content_copy';
  readonly description =
    'Find and remove duplicate media files for this patient';
  readonly resource = ManagementResource.Patient;

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const value = await snapshot(context.resource.value$);
    if (!value || !isPatientWithRef(value)) {
      return;
    }
    const data: IDeduplicatePatientMediaDialogData = { patient: value };
    this._dialog.open(
      DeduplicatePatientMediaDialogComponent,
      DialogPresets.medium({ data })
    );
  }
}
